import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getServiceRequestConfigV2 } from '@/services/apiService.service';
import { CatalogConfig } from '@/types/serviceRequestsCatalogV2.types';
import { ServiceRequestContent } from '@/types/useCatalogV2.types';

interface ServiceRequestCatalogState {
  catalogConfig: CatalogConfig;
  loading: boolean;
  error: string | null;
}

const initialState: ServiceRequestCatalogState = {
  catalogConfig: { categories: [] },
  loading: false,
  error: null,
};

export const fetchServiceRequestCatalogConfig = createAsyncThunk(
  'serviceRequestCatalog/fetchConfig',
  async (payload: Record<string, unknown>) => {
    const response = await getServiceRequestConfigV2(payload);
    return response?.serviceRequestCatalog;
  }
);

const serviceRequestCatalogSlice = createSlice({
  name: 'serviceRequestCatalog',
  initialState,
  reducers: {
    resetServiceRequestCatalog: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceRequestCatalogConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServiceRequestCatalogConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.catalogConfig = action.payload || {};
      })
      .addCase(fetchServiceRequestCatalogConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch service request catalog config';
      });
  },
});

export const { resetServiceRequestCatalog } = serviceRequestCatalogSlice.actions;
export default serviceRequestCatalogSlice.reducer;
